import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "./DashboardProductTable.module.scss";

function DashboardProductTable({
  data,
  title,
  figured,
}: {
  data: any[];
  title?: string;
  figured?: boolean;
}) {
  let chartData = data.map((each: any) => ({
    name: each.tradingname,
    amount: each.transaction_amount,
  }));

  return (
    <div
      style={{
        height: "100%",
        margin: "10px 10px 0px 10px",
      }}
    >
      {data.length > 0 ? (
        <ResponsiveContainer
          width="100%"
          height="100%"
          className={styles.chart}
        >
          <BarChart
            width={80}
            height={50}
            data={chartData}
            layout={"vertical"}
            barCategoryGap={2}
          >
            <Bar dataKey="amount" fill="#99DDB5" />
            <XAxis type="number" />
            {/* <YAxis dataKey="name" /> */}
            {/* <CartesianGrid horizontal={false} z={-1} /> */}
            <Tooltip />
            <YAxis
              type="category"
              // width={10}
              // height={10}
              padding={{ top: 10 }}
              dataKey="name"
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontWeight: "bold",
          }}
        >
          No Data Found
        </p>
      )}
    </div>
  );
}

export default DashboardProductTable;
